import tpl from './templates';
import tplDvigMah from './templates_dvigatel_mahovik';
import tplDvigPat from './templates_dvigatel_patrubki';
import tplDvigKlapEgr from './templates_dvigatel_klapan-egr';
import tplElAbs from './templates_elektrika-i-elektronika_datchik-abs';
import tplElDatch from './templates_elektrika-i-elektronika_datchik';

export const AUTO = {
  transport: tpl.transport,
  make: tpl.make,
  make_model: tpl.make_model,

  city: tpl.city,
  city_make: tpl.city_make,
  city_make_model: tpl.city_make_model,
};

export const AVTO_DVIGATEL_MAHOVIK = {
  make: tplDvigMah.make,
};

export const AVTO_DVIGATEL_PATRUBKI = {
  make: tplDvigPat.make,
};

export const AVTO_DVIGATEL_KLAPANI__EGR = {
  make: tplDvigKlapEgr.make,
};

export const AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI = {
  make: tplElDatch.make,
};

export const AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS = {
  make: tplElAbs.make,
};



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/index.js